import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseApi from "../../api/baseApi";

import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialState = {
  customer: {},
  customerLoading: true,
  customerRefresh: true,

  customers: [],
  customersLoading: true,
  customersRefresh: true,

  customersAgency: [],
  customersAgencyLoading: true,
  customersAgencyRefresh: true,

  createCustomerLoading: false,
  updateCustomerLoading: false,
  deleteCustomerLoading: false,
};

export const fetchCustomer = createAsyncThunk(
  "customer/fetchCustomer",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    try {
      const response = await baseApi.get(`/Customer/${id}`);

      return response.data.Value;
    } catch (error) {
      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const updateCustomer = createAsyncThunk(
  "customer/updateCustomer",
  async (values) => {
    if (!values) {
      throw new Error("Veri bulunamadı!");
    }

    const data = {
      id: values.id,
      customerName: values.customerName,
      phoneNumber: values.phoneNumber,
      email: values.email,
      isActive: values.isActive,
      taxNumber: values.taxNumber,
      taxOffice: values.taxOffice,
      city: values.city,
      district: values.district,
      address: values.address,
      agencyId: values.agencyId,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.put(`/Customer/${values.id}`, data);

      toast.update(loadingToast, {
        render: "Kaydedildi.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const customerSlice = createSlice({
  name: "customer",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomer.pending, (state, action) => {
        state.customer = {};
        state.customerLoading = true;
      })
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.customer = action.payload;
        state.customerLoading = false;
      })
      .addCase(fetchCustomer.rejected, (state, action) => {
        state.customer = {};
        state.customerLoading = false;
      });

    builder
      .addCase(updateCustomer.pending, (state, action) => {
        state.updateCustomerLoading = true;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.updateCustomerLoading = false;
        state.customersRefresh = !state.customersRefresh;
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.updateCustomerLoading = false;
      });
  },
});

export default customerSlice.reducer;
